import { GridValidRowModel } from '@mui/x-data-grid-pro';
import { Union } from 'ts-toolbelt';

import { NULLISH_CELL_VALUE } from '../../DataGridCustom.types';
import { TsrctNegotiationCaseStatus } from '@/generated/gql/graphql';
import { NegotiationStatusChip } from '~/components/NegotiationStatusChip/NegotiationStatusChip';

export type NegotiationStatusChipCellValue = Union.Nullable<keyof typeof TsrctNegotiationCaseStatus>;

interface NegotiationStatusChipCellProps<R extends GridValidRowModel = any> {
  value: NegotiationStatusChipCellValue;
  row: R;
}

export const NegotiationStatusChipCell = <R extends GridValidRowModel = any>({
  value,
}: NegotiationStatusChipCellProps<R>) => {
  // div wrapper needed to display chip correctly
  return value ? (
    <div style={{ width: '100%' }}>
      <NegotiationStatusChip status={value} />
    </div>
  ) : (
    <>{NULLISH_CELL_VALUE}</>
  );
};
